import React from 'react';

const Loading = () => (
    <div className="loadingContainer">
        <img src={`/imgs/giphy.gif`} className="imgLoading"/>
    </div>
)
export default Loading
